import React, { useCallback } from 'react'
import styled from 'styled-components'

import i18n from 'live/services/i18n'

import { StageOverviewDropdownButtonRegistry } from 'plugin-joblog/shared/lib/stage-overview-header-dropdown-registry'
import { canAccessPSR } from '../permissions/permissions'

const registerStageOverviewHeaderButton = (fracEventAlias: string, postStageReportAlias: string) =>
    StageOverviewDropdownButtonRegistry.register({
        title: i18n('Post Stage Report'),
        iconCls: 'far fa-file-alt',
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, react/display-name
        Component: props => {
            const getButton = useCallback((): React.ReactElement => {
                return (
                    <LinkLikeButton
                        onClick={() => {
                            const basePath = window.location.pathname
                            const hash = `/${fracEventAlias}/${postStageReportAlias}/${props.stageKPIs.crewId}/run/${props.stageKPIs.eventUid}`

                            const url = `${basePath}#${hash}`

                            window.open(url, '_blank', 'noopener,noreferrer')
                        }}
                    >
                        <span>{i18n('Post Stage Report')}</span>
                    </LinkLikeButton>
                )
            }, [props])

            return canAccessPSR() ? getButton() : null
        }
    })

export default registerStageOverviewHeaderButton

const LinkLikeButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    color: var(--blue-500);
    text-decoration: none;
    cursor: pointer;

    :hover {
        text-decoration: underline;
    }
`
